export enum TabType {
  Aktuelle = "Aktuelle",
  Tidligere = "Tidligere",
}
